module.exports = __webpack_public_path__ + "img/transport-1.c098a212.png";